import { render, staticRenderFns } from "./duicuo.vue?vue&type=template&id=7c2749be&scoped=true&"
import script from "./duicuo.vue?vue&type=script&lang=js&"
export * from "./duicuo.vue?vue&type=script&lang=js&"
import style0 from "./duicuo.vue?vue&type=style&index=0&id=7c2749be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2749be",
  null
  
)

export default component.exports